import { IconButton, styled } from "@mui/material";

export default function WrapperAction({
  data,
  setDetailsReferral,
  setOpenDetailsReferralModal,
}) {
  return (
    <IconButtonStyle
      aria-label="history"
      size="small"
      onClick={() => {
        setDetailsReferral(data);
        setOpenDetailsReferralModal(true);
      }}
    >
      <ion-icon name="eye-outline" />
    </IconButtonStyle>
  );
}

const IconButtonStyle = styled(IconButton)(({ theme }) => ({
  "ion-icon": {
    color: theme.palette.text.secondary,
    fontSize: "22px",
  },
}));
